const name = process.env.REACT_APP_NAME as string;
const clientId = process.env.REACT_APP_CLIENT_ID as string;
const authority = process.env.REACT_APP_AUTHORITY as string;
const redirectUri = process.env.REACT_APP_REDIRECT_URI as string;
const baseUrl = process.env.REACT_APP_BASE_URL as string;
const title = process.env.REACT_APP_TITLE as string;
const chunkSize = parseInt(process.env.REACT_APP_CHUNK_SIZE as string, 10);

const knownAuthority = new URL(authority).hostname;

export const envConfig = {
  auth: {
    clientId,
    authority,
    knownAuthorities: [knownAuthority],
    redirectUri,
  },
  api: {
    baseUrl,
  },
  app: {
    title,
    name,
    chunkSize,
  },
};